
const defaultSettings = {
    minLength: 8,
    zxcvbnMinLevel: 1,
    useHibp: true,
    useZxcvbn: true,
};

function ChangePassword() {
    const l11n = window.password_l11n || {};
    const settings = {};
    Object.assign(settings, defaultSettings);
    Object.assign(settings, window.password_settings || {});


    const newEl = document.getElementById('newpassword');
    const confirmEl = document.getElementById('confirmpassword');
    let shown = false;

    if (!newEl || !confirmEl)
        return;


    confirmEl.addEventListener('change', checkPaswordsMatch);
    confirmEl.addEventListener('input', checkPaswordsMatch);
    confirmEl.addEventListener('blur', checkPaswordsMatch);

    if (settings.useZxcvbn || settings.useHibp) {
        const zxcvbnimport = settings.useZxcvbn ? import('zxcvbn') : null;
        const hibpimport = settings.useHibp ? import('hibp') : null;

        let sequence = 0;

        async function checkSecurity(e) {
            checkPaswordsMatch(e);
            newEl.setCustomValidity("");
            if (!newEl.validity.valid) {
                if (shown) {
                    if (newEl.validity.tooShort)
                        setPasswordFeedback(0, l11n.tooShort);
                    else
                        setPasswordFeedback(0);
                }
                return;
            }
            shown = true;
            newEl.setCustomValidity("Validating...");
            const pw = newEl.value;

            if (settings.useZxcvbn) {
                const me = ++sequence;
                const { default: zxcvbn } = await zxcvbnimport;
                if (me !== sequence)
                    return;
                const r = zxcvbn(pw);

                if (document.documentElement.lang === 'en') {
                    for (const tip of document.querySelectorAll('.password-tip')) {
                        tip.innerHTML = '';

                        const tips = formatSuggestions(r);
                        if (tips)
                            tip.appendChild(tips);
                    }
                }

                const minLevel = settings.zxcvbnMinLevel === 0 ? 0 : settings.zxcvbnMinLevel || 1;
                if (r.score < minLevel) {
                    newEl.setCustomValidity(l11n.noScore || r.warning);
                    setPasswordFeedback(r.score);
                    return;
                }

                newEl.setCustomValidity("");
                setPasswordFeedback(r.score);
            } else {
                newEl.setCustomValidity("");
                clearPasswordFeedback();
            }

            if (settings.useHibp) {
                const me = ++sequence;
                const hibp = await hibpimport;
                const pwned = await hibp.pwnedPassword(pw)
                if (me !== sequence)
                    return;

                if (pwned) {
                    newEl.setCustomValidity(l11n.hibp || "This password is known");
                    setPasswordFeedback(0, l11n.hibp || "This password is known");
                    return;
                }
            }
        }

        newEl.addEventListener('change', checkSecurity);
        newEl.addEventListener('input', checkSecurity);
        newEl.addEventListener('blur', e => {
            shown = true;
            checkSecurity(e);
        });
    }

    function checkPaswordsMatch(e) {
        if (confirmEl.value === newEl.value)
            confirmEl.setCustomValidity("");
        else
            confirmEl.setCustomValidity(l11n.doesNotMatch || "Passwords do not match");
    }

    function clearPasswordFeedback() {
        for (const el of document.querySelectorAll('.password-strength')) {
            el.classList.remove('show');
        }
    }

    function setPasswordFeedback(score, message) {
        let showLabel = !message;
        let meterText = undefined;
        let alertClass = undefined;
        switch (score) {
            default:
                meterText = l11n.noScore;
                alertClass = 'danger';
                break;
            case 1:
                meterText = l11n.lowScore;
                alertClass = 'danger';
                break;
            case 2:
                meterText = l11n.okScore;
                alertClass = 'warning';
                break;
            case 3:
                meterText = l11n.goodScore;
                alertClass = 'info';
                break;
            case 4:
                meterText = l11n.highScore;
                alertClass = 'success';
                break;
        }

        if (!message)
            message = meterText;

        for (const el of document.querySelectorAll('.password-strength')) {
            for (const meter of el.querySelectorAll('.progress .progress-bar')) {
                const min = +meter.getAttribute('aria-valuemin');
                const max = +meter.getAttribute('aria-valuemax');

                const progress = (score - min) / (max - min);

                meter.setAttribute('aria-valuenow', score);
                meter.style.width = (progress * 100).toString() + '%';
                meter.classList.remove('bg-danger', 'bg-warning', 'bg-info', 'bg-success');
                if (alertClass)
                    meter.classList.add(`bg-${alertClass}`);
            }

            for (const txt of el.querySelectorAll('.feedback')) {
                txt.innerHTML = message;
            }

            for (const lbl of el.querySelectorAll('.feedback-label')) {
                if (showLabel)
                    lbl.style.display = '';
                else
                    lbl.style.display = 'none';
            }

            for (const alert of el.querySelectorAll('.alert')) {
                alert.classList.remove('alert-danger', 'alert-warning', 'alert-light', 'alert-success');
                if (alertClass)
                    alert.classList.add(`alert-${alertClass}`);
            }
            el.classList.add('show');
        }
    }

    function formatSuggestions(r) {
        if (!r.feedback.warning)
            return null;

        const div = document.createElement('div');
        const h5 = document.createElement('h5');
        h5.classList.add('mt-3', 'mb-0', 'font-weight-bold');
        h5.textContent = r.feedback.warning;
        div.appendChild(h5);

        if (r.feedback.suggestions.length > 0) {
            const span = document.createElement('span');
            span.textContent = 'Tips for selecting a more secure pasword:';

            div.appendChild(span);

            const ul = document.createElement('ul');
            ul.classList.add('mb-0', 'pl-3');
            for (const suggestion of r.feedback.suggestions) {
                const li = document.createElement('li');
                li.textContent = suggestion;
                ul.appendChild(li);
            }
            div.appendChild(ul);
        }
        return div;
    }
};

export default ChangePassword;